import eventHub from '@/scripts/eventHub';
import store from '@/store';
import vars from './vars';

const state = {
  _maxLife: 3,
  _score: 0,
  _coins: 0,
  _hitCounter: 0,
  _level: 1,
  _paused: true,
  _gameover: false,

  spawnDelay: 25,
  foregroundSpeed: 3,
  backgroundSpeed: 1,
  limitCoins: 10,
  previousPosition: 'up',
  light: false,
  heavy: false,

  get life() { return state.maxLife - state.hitCoutner; },
  get score() { return this._score; },
  set score(score) {
    this._score = score;
    store.commit('SET_SCORE', this.score);
    const level = vars.levels.get(this._level);
    if (state.score !== 0 && state.score % level.duration === 0) { state.level += 1; }
  },
  get coins() { return this._coins; },
  set coins(coins) {
    this._coins = coins;
    store.commit('SET_COINS', this.coins);

    if (this._coins >= this.limitCoins) {
      eventHub.$emit('power');
    }
  },
  get hits() { return state._hitCounter; },
  set hits(hits) {
    state._hitCounter = hits;
    eventHub.$emit('hit');

    store.commit('SET_LIFE', state._maxLife - state._hitCounter);
    if (state._hitCounter >= state._maxLife) {
      this.gameover = true;
      eventHub.$emit('gameover');
    }
  },
  get level() { return this._level; },
  set level(value) {
    console.log(`Got to level ${value}`);
    this._level = value;
    const l = vars.levels.get(value);
    if (typeof l !== 'undefined') { // Before max level
      // Update params for level change
      state.spawnDelay = l.spawnDelay;
      state.foregroundSpeed = l.foregroundSpeed;
      eventHub.$emit('levelchange');
    }
    store.commit('SET_LEVEL', state._level);
  },
  get paused() { return this._paused; },
  set paused(value) {
    this._paused = value;
    if (this._paused) {
      store.commit('SET_MODE', 'paused');
    } else {
      store.commit('SET_MODE', 'playing');
    }
  },
  get gameover() { return this._gameover; },
  set gameover(value) {
    this._gameover = value;
    if (this._gameover) store.commit('SET_MODE', 'gameover');
  },

  reset() {
    this.hits = 0;
    this.level = 1;
    this.score = 0;
    this.coins = 0;
  },
};

export default state;
